import { createSlice } from '@reduxjs/toolkit';
import { strText } from '../../../constants';


const initialState = {
    transfereeUserLoading: false,
    transfereeUserErrorMsg: null,
    transfereeUserSuccessMsg: null,
    certificateManagement: {
        certificatesData: [],
        newData: false,
        additionalDocs: [],
        certificateDetails: '',
        showCertificateForm: false,
        showCertificateUpdateForm: false,
        showStatusChangeConfirmation: false,
        showUploadSuccessModal: false,
        showResendLinkConfirmation: false,
        showRequestBalance: false,
        showCommentFormTrans: false,
        comments: [],
        newComment: false,
        updCertificate: false,
        // certificateStatus: '',
        // certificateStatusConfirmationBtnText: '',
        // documentType: 'Certificate'
    },
    userManagement: {
        usersData: []
    },
    searchResult: {
        searchResultData: {},
        newData: false,
        searchResultDetails: '',
        certificateSearchValue: '',
    },
    digitalLetterManagement: {
        inboxLetters: [],
        draftLetters: [],
        sentLetters: [],
        inboxLetterDetails: '',
        draftLetterDetails: '',
        sentLetterDetails: '',
        activeEmailTab: 'inbox',
        showDeleteConfirmationForm: false,
        showAttachmentModal: false,
        newLetter: false
        // letterStatus: ''
    },
    currencies: []
}

export const transfereeUserSlice = createSlice({
    name: 'transfereeUserApp',
    initialState,
    reducers: {
        clearAll: (state, action) => {
            state.transfereeUserLoading = false
            state.transfereeUserErrorMsg = null
            state.transfereeUserSuccessMsg = null
        },
        clearOnReload: (state, action) =>{
            state.certificateManagement = {
                ...initialState.certificateManagement,
                certificateDetails: state.certificateManagement.certificateDetails
            }
            state.digitalLetterManagement = {
                ...initialState.digitalLetterManagement,
                inboxLetterDetails: state.digitalLetterManagement.inboxLetterDetails,
                sentLetterDetails: state.digitalLetterManagement.sentLetterDetails,
                draftLetterDetails: state.digitalLetterManagement.draftLetterDetails
            }
            state.searchResult = {
                ...initialState.searchResult,
                certificateSearchValue: state.searchResult.certificateSearchValue
            }
        },
        clearResponseMsg: (state, action) => {
            state.transfereeUserErrorMsg = null
            state.transfereeUserSuccessMsg = null

        },
        setLoadingTransfereeUser: (state, action) => {
            state.transfereeUserLoading = action?.payload?.loading
        },
        clearResetBot: (state) => {
            state.certificateManagement.newData = false
            state.certificateManagement.newComment = false
            state.certificateManagement.updCertificate = false
            state.digitalLetterManagement.newLetter = false
            state.searchResult.newData = false
        },
        setErrorMessageTransfereeUser: (state, action) => {
            let msg = action.payload.message
            state.transfereeUserLoading = false
            state.transfereeUserErrorMsg = msg
        },
        setSuccessMessagetransfereeUser: (state, action) => {
            let msg = action.payload.message
            state.transfereeUserLoading = false
            state.transfereeUserSuccessMsg = msg
        },
        logoutTransfereeUser: (state, action) => {
              return initialState
        },
        onGetComments: (state, action) => {
            state.transfereeUserSuccessMsg = ''
            state.certificateManagement.comments = action.payload
        },
        onGetCurrencies: (state, action)=>{
            state.currencies = action.payload
        },
        onGetInboxLetters: (state, action) => {
            state.transfereeUserSuccessMsg = ''
            state.digitalLetterManagement.inboxLetters = action.payload
        },
        onGetDraftLetters: (state, action) => {
            state.transfereeUserSuccessMsg = ''
            state.digitalLetterManagement.draftLetters = action.payload
        },
        onGetSentLetters: (state, action) => {
            state.transfereeUserSuccessMsg = ''
            state.digitalLetterManagement.sentLetters = action.payload
        },
        onAddComment: (state, action) => {
            state.transfereeUserSuccessMsg = action.payload.message
            // state.certificateManagement.newComment = true
        },
        onSendLetter: (state, action) => {

            state.transfereeUserSuccessMsg = action.payload.message
        },
        onSearch: (state, action) => {
            state.searchResult.certificateSearchValue = action.payload.searchValue
        },
        onDeleteLetter: (state, action) => {
            state.transfereeUserSuccessMsg = "Letter Deleted Successfully"
            state.digitalLetterManagement.showDeleteConfirmationForm = false
            state.digitalLetterManagement.newLetter = true
        },
         onChangeStatus: (state, action) => {
            state.transfereeUserSuccessMsg = action.payload.message
            state.certificateManagement.certificateDetails = {...state.certificateManagement.certificateDetails, CERTIFICATE_STATUS: action.payload.status}
            state.digitalLetterManagement.showStatusChangeConfirmation = false
        },
        // onShowAttachment: (state, action) => {
        //     state.digitalLetterManagement.showAttachmentModal = false
        // },
        showCertificateFormFunc: (state, action) => {
            state.certificateManagement.showCertificateForm = action.payload.modal
        },
        showCertificateUpdateFormFunc: (state, action) => {
            state.certificateManagement.showCertificateUpdateForm = action.payload.modal
        },
        showCommentFormFunc: (state, action) => {
            state.certificateManagement.showCommentFormTrans = action.payload.modal
        },
        showDeleteConfirmationFunc: (state, action) => {
            state.digitalLetterManagement.showDeleteConfirmationForm = action.payload.modal
        },
        // showStatusChangeConfirmationFunc: (state, action) => {
        //     state.certificateManagement.showStatusChangeConfirmation = action.payload.modal
        // },
        showAttachmentFunc: (state, action) => {
            state.digitalLetterManagement.showAttachmentModal = action.payload.modal
        },
        setCertificateDetails: (state, action) => {
            state.certificateManagement.certificateDetails = action.payload.details
            // state.certificateManagement.showCustomerSuccessModal = action.payload.modal
        },
        setSearchResultDetails: (state, action) => {
            state.searchResult.searchResultDetails = action.payload.details
            // state.certificateManagement.showCustomerSuccessModal = action.payload.modal
        },
        setInboxLetterDetails: (state, action) => {
            state.digitalLetterManagement.inboxLetterDetails = action.payload.details
            // state.certificateManagement.showCustomerSuccessModal = action.payload.modal
        },
        setDraftLetterDetails: (state, action) => {
            state.digitalLetterManagement.draftLetterDetails = action.payload.details
            // state.certificateManagement.showCustomerSuccessModal = action.payload.modal
        },
        setSentLetterDetails: (state, action) => {
            state.digitalLetterManagement.sentLetterDetails = action.payload.details
            // state.certificateManagement.showCustomerSuccessModal = action.payload.modal
        },
        onGetSearchResult: (state, action) => {
            state.transfereeUserSuccessMsg = ''
            // state.searchResult.searchResultData = action.payload
            // state.searchResult.newData = true
        },
        setActiveEmailTab: (state, action) => {
            state.digitalLetterManagement.activeEmailTab = action.payload.name
        },
        onGetUsers: (state, action) => {
            state.transfereeUserSuccessMsg = ''
            state.userManagement.usersData = action.payload
        },
        onGetCertificates: (state, action) => {
            state.transfereeUserSuccessMsg = ''
            state.certificateManagement.certificatesData = action.payload
            state.certificateManagement.newData = true
        },
        onAddCertificate: (state, action) => {
            state.certificateManagement.showCertificateForm = false
            state.transfereeUserErrorMsg = ''
            state.transfereeUserSuccessMsg = 'Certificate Uploaded Successfully'
            state.certificateManagement.showUploadSuccessModal = true
        },
        onUpdateCertificate: (state, action) => {
            state.certificateManagement.showCertificateUpdateForm = false
            state.certificateManagement.updCertificate = true
            state.transfereeUserErrorMsg = ''
            state.transfereeUserSuccessMsg = 'Certificate Uploaded Successfully'
            // state.certificateManagement.showUploadSuccessModal = true
        },
        showUploadSuccessModalFunc: (state, action) => {
            state.certificateManagement.showUploadSuccessModal = action.payload.modal
        },
        showResendLinkConfirmationFunc: (state, action) => {
            state.certificateManagement.showResendLinkConfirmation = action.payload.modal
        },
        showRequestBalanceFunc: (state, action) => {
            state.certificateManagement.showRequestBalance = action.payload.modal
        },
        onResendLinkToBank: (state, action) => {
            state.transfereeUserSuccessMsg = action.payload.message
            state.certificateManagement.showResendLinkConfirmation = false
        },
        onRequestBalance: (state, action) => {
            state.transfereeUserSuccessMsg = 'Balance request successful'
            state.certificateManagement.certificateDetails = {...state.certificateManagement.certificateDetails, CAN_REQUEST_BALANCE: '0'}
            state.certificateManagement.showRequestBalance = false
        },
        // setConfirmationStatusModalText: (state, action) =>{
        //     state.certificateManagement.certificateStatus = action.payload.status ?? state.certificateManagement.certificateStatus
        //     state.certificateManagement.certificateStatusConfirmationBtnText = action.payload.btnText ?? state.certificateManagement.certificateStatusConfirmationBtnText
        //     state.certificateManagement.documentType = action.payload.documentType ??  state.certificateManagement.documentType
        // }
        onGetAdditionalDocuments: (state, action) => {
            state.transfereeUserSuccessMsg = ''
            state.certificateManagement.additionalDocs = action.payload
        },
    },
});

// Action creators are generated for each case reducer function
export const {
    clearAll,
    clearResetBot,
    setErrorMessageTransfereeUser,
    setLoadingTransfereeUser,
    setSuccessMessageTransfereeUser,
    onGetCertificates,
    setCertificateDetails,
    onGetComments,
    onChangeStatus,
    onGetSearchResult,
    showCertificateFormFunc,
    showCertificateUpdateFormFunc,
    showCommentFormFunc,
    showDeleteConfirmationFunc,
    // showStatusChangeConfirmationFunc,
    onAddCertificate,
    onUpdateCertificate,
    onAddComment,
    onGetCurrencies,
    onDeleteLetter,
    onGetInboxLetters,
    onGetDraftLetters,
    onGetSentLetters,
    clearResponseMsg,
    clearOnReload,
    logoutTransfereeUser,
    setInboxLetterDetail,
    setActiveEmailTab,
    onSendLetter,
    onGetUsers,
    setInboxLetterDetails,
    setDraftLetterDetails,
    setSentLetterDetails,
    showAttachmentFunc,
    onSearch,
    setSearchResultDetails,
    showResendLinkConfirmationFunc,
    showRequestBalanceFunc,
     showUploadSuccessModalFunc,
    onResendLinkToBank,
    onRequestBalance,
    setConfirmationStatusModalText,
    onGetAdditionalDocuments
} = transfereeUserSlice.actions

export default transfereeUserSlice.reducer